<template> 
    <el-col :xs="{span:24}" :md="md" class="el-form-item--large" :class="className" v-show="defaultShow">
       <el-card body-class="el-row"> 
            <component v-for="field in settings.Components"
                        :key="field.Name"
                        :is="field.FieldDefinition.Name"
                        :definition="field"
                        :data="data"
                        :htmlPrefix="htmlPrefix"
                        :contentType="contentType"
                        :formDefinition = "formDefinition"
                        :orginalDisplay = "orginalDisplay">
            </component>
       </el-card>
    </el-col>
</template>

<script>
    import BaseLayout from "./LayoutBase";
    export default {
        name:"qweCard",
        commponentName:"qweCard",
        mixins: [BaseLayout],
        created:function(){

        },
        computed:{
            md:function(){
                return {
                    span:this.settings.Width,
                    offset:0
                };
            }
        },

        methods:{
            handleChildrens:function(){

            }
        }
    }
</script>